<template>
<page-wrapper>
  <v-row dense class="top-controls">
    <v-spacer></v-spacer>
    <v-btn color="primary" depressed @click="openAdd">New item</v-btn>
  </v-row>

  <v-data-table :headers="headers" :items="stockItems"
                :items-per-page="100" hide-default-footer
                elevation="0" class="mt-2">
    <template v-slot:item.name="{ item }">
      <span v-if="!item.editing">{{ item.name }}</span>
      <v-text-field v-else v-model="item.editName" dense hide-details autofocus
                    @keyup.enter="saveRename(item)"
                    @keyup.esc="cancelRename(item)"></v-text-field>
    </template>
    <template v-slot:item.actions="{ item }">
      <template v-if="!item.editing">
        <v-icon small class="mr-2" @click="startRename(item)">mdi-pencil</v-icon>
        <v-icon small @click="confirmDelete(item)">mdi-delete</v-icon>
      </template>
      <template v-else>
        <v-icon small class="mr-2" color="primary" @click="saveRename(item)">mdi-check</v-icon>
        <v-icon small @click="cancelRename(item)">mdi-close</v-icon>
      </template>
    </template>
  </v-data-table>

  <v-dialog v-model="addDialog" max-width="400px">
    <v-card>
      <v-card-title>New stock item</v-card-title>
      <v-card-text>
        <v-text-field v-model="newName" label="Name" autofocus autocomplete="off"
                      @keyup.enter="addItem"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="addDialog = false">Cancel</v-btn>
        <v-btn text color="primary" @click="addItem">Add</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="deleteDialog" max-width="360px">
    <v-card>
      <v-card-title>Delete item?</v-card-title>
      <v-card-text>
        <span v-if="deleteError" class="error--text">{{ deleteError }}</span>
        <span v-else>Delete <strong>{{ deleteTarget && deleteTarget.name }}</strong>?</span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="deleteDialog = false">Cancel</v-btn>
        <v-btn v-if="!deleteError" text color="error" @click="deleteItem">Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</page-wrapper>
</template>

<script>
import * as api from '../api'
import PageWrapper from '../components/ui/PageWrapper'

export default {
  name: 'StockItems',
  components: { PageWrapper },
  data() {
    return {
      stockItems: [],
      headers: [
        { text: 'Name', value: 'name' },
        { text: '', value: 'actions', sortable: false, width: '80px', align: 'right' }
      ],
      addDialog: false,
      newName: '',
      deleteDialog: false,
      deleteTarget: null,
      deleteError: null
    }
  },
  methods: {
    openAdd() {
      this.newName = ''
      this.addDialog = true
    },
    async addItem() {
      if (!this.newName.trim()) return
      await api.post('/stock-item', { name: this.newName.trim() })
      this.addDialog = false
      await this.refresh()
    },
    startRename(item) {
      item.editName = item.name
      this.$set(item, 'editing', true)
    },
    cancelRename(item) {
      this.$set(item, 'editing', false)
    },
    async saveRename(item) {
      if (!item.editName.trim() || item.editName === item.name) {
        this.cancelRename(item)
        return
      }
      await api.put(`/stock-item/${item.id}`, { name: item.editName.trim() })
      this.$set(item, 'editing', false)
      await this.refresh()
    },
    confirmDelete(item) {
      this.deleteTarget = item
      this.deleteError = null
      this.deleteDialog = true
    },
    async deleteItem() {
      try {
        await api.del(`/stock-item/${this.deleteTarget.id}`)
        this.deleteDialog = false
        await this.refresh()
      } catch (e) {
        this.deleteError = e.detail || 'Cannot delete this item'
      }
    },
    async refresh() {
      const items = await api.get('/stock-items')
      this.stockItems = items.map(i => ({ ...i, editing: false, editName: '' }))
    }
  },
  async created() {
    await this.refresh()
  }
}
</script>

<style scoped lang="scss">
.top-controls {
  width: 100%;
  align-items: center;
  > * { margin: 5px 10px; }
}
</style>
